<template>
	<div>
		<DetailTitle title="조회 기간"></DetailTitle>

		<SearchDateRange
			:start-date="searchStartDate"
			:end-date="searchEndDate"
			@search="search"
		/>

		<div class="stamp-history-status-container u-container">
			<AsStampHistoryStatusListItem
				v-for="(item, index) in userAsList"
				:key="index"
				:as-detail="userAsList[index]"
			/>

			<InfiniteLoading
				v-if="isInfiniteLoading"
				ref="infiniteLoading"
				@infinite="infinite"
			></InfiniteLoading>
		</div>
	</div>
</template>

<script>
import '@/assets/css/as-stamp-history.css';

import DetailTitle from '@/components/common/DetailTitle';
import SearchDateRange from '@/components/common/SearchDateRange';
import InfiniteLoading from '@/components/common/InfiniteLoading';
import AsStampHistoryStatusListItem from './AsStampHistoryStatusListItem';

import { formatDate } from '@/utils/util';

export default {
	components: {
		DetailTitle,
		SearchDateRange,
		InfiniteLoading,
		AsStampHistoryStatusListItem,
	},
	data() {
		return {
			page: 1,
			startDate: '',
			endDate: '',
			isInfiniteLoading: false,
		};
	},
	computed: {
		limitStartDate() {
			return new Date('2022-01-1');
		},
		searchStartDate() {
			const date = new Date();
			date.setMonth(date.getMonth() - 3);
			return this.limitStartDate.getTime() > date.getTime()
				? this.limitStartDate
				: date;
		},
		searchEndDate() {
			return new Date();
		},
		userId() {
			return this.$store.getters['userStore/userId'];
		},
		userAsList() {
			return this.$store.getters['asStore/userAsList'];
		},
	},
	created() {
		this.initUserAsList();
	},
	methods: {
		async fetchUserAsList() {
			const payload = {
				userId: this.userId,
				page: this.page,
				startDate: this.startDate,
				endDate: this.endDate,
			};
			return await this.$store.dispatch('asStore/getUserAsList', payload);
		},
		initUserAsList() {
			this.$store.dispatch('asStore/initUserAsList');
		},
		infinite(state) {
			this.fetchUserAsList().then(({ data }) => {
				if (data.code !== '00000' || data.page > data.totalPage) {
					this.page--;
					state.complete();
				}
				if (data.page <= data.totalPage) {
					this.page++;

					/**
					 * 데이터 가져오는 속도가 빨라서
					 * 스크롤시 무한 스크롤링 로딩 아이콘 노출 시간이 짧아서 보이지 않음.
					 * 임의로 가져오는 속도 늦춤.
					 */
					setTimeout(() => state.loaded(), 400);
				}
			});
		},
		setDateRange(date) {
			this.startDate = formatDate(date.start, '');
			this.endDate = formatDate(date.end, '');
		},
		search(date) {
			this.setDateRange(date);

			this.isInfiniteLoading === false
				? (this.isInfiniteLoading = true)
				: this.initRender();
		},
		initRender() {
			this.page = 1;
			this.initUserAsList();
			this.$refs.infiniteLoading.resetInfiniteLoading();
		},
	},
};
</script>
